(function () {
  if (window.__itemManagerColorSwatchesBound) return;
  window.__itemManagerColorSwatchesBound = true;

  // Color swatches keep rendering from the theme's swatch_value_list as the base
  // (unchanged). This layers the managed color source (item-manager) on top so
  // chip colors can be edited centrally. Only the color variable is overridden;
  // names not in the source, and image swatches, keep the theme's base value.
  //
  // It also layers the per-color sold-out diagonal color: cards read
  // --swatch-soldout-line-color (see item-manager-swatch-overrides.css) and the
  // product page swatches read --swatch-cross-svg (a recolored diagonal SVG).
  // A brand-level default (applied at :root) covers colors without a per-color
  // value; when nothing is set the theme's current diagonal color is kept.
  var defaultApiBaseUrl = "https://admin.e-asakura.net";
  var BRAND = "en-neume";
  var colorMap = null;

  function normalize(value) {
    return String(value == null ? "" : value)
      .replace(/"/g, "")
      .trim()
      .toLowerCase();
  }

  // Recolored copy of the theme's sold-out diagonal SVG (doc-head-styles.liquid),
  // identical geometry, only the stroke color swapped.
  function buildCrossSvg(color) {
    var stroke = encodeURIComponent(color);
    return (
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' " +
      "width='240' height='240' viewBox='0 0 24 24' fill='none' stroke='" +
      stroke +
      "' stroke-width='0.09' preserveAspectRatio='none' %3E" +
      "%3Cline x1='24' y1='0' x2='0' y2='24'%3E%3C/line%3E%3C/svg%3E\")"
    );
  }

  function applyLineColor(element, color) {
    if (!color) return;
    element.style.setProperty("--swatch-soldout-line-color", color);
    var cross = buildCrossSvg(color);
    element.style.setProperty("--swatch-cross-svg", cross);
    element.style.setProperty("--swatch-cross-hover", cross);
    element.style.setProperty("--swatch-cross-active", cross);
  }

  function buildColorMap(payload) {
    var map = {};
    var swatches = (payload && payload.swatches) || [];
    for (var i = 0; i < swatches.length; i++) {
      var swatch = swatches[i];
      var entry = {
        kind: swatch.swatchKind,
        value: swatch.swatchValue,
        line: swatch.soldOutLineColor || null,
      };
      if (swatch.name) map[normalize(swatch.name)] = entry;
      var aliases = swatch.aliases || [];
      for (var j = 0; j < aliases.length; j++) {
        map[normalize(aliases[j])] = entry;
      }
    }
    return map;
  }

  function applyToElement(element) {
    if (!colorMap || element.getAttribute("data-im-color-applied") === "1")
      return;
    var key = normalize(element.getAttribute("data-swatch"));
    if (!key) return;
    var entry = colorMap[key];
    if (!entry) return;
    // Per-color sold-out diagonal color (applies to all kinds, incl. image).
    applyLineColor(element, entry.line);
    // Chip background color (hex/gradient only; image keeps the theme base).
    if (entry.value && entry.kind === "hex") {
      element.style.setProperty("--swatch-background-color", entry.value);
    } else if (entry.value && entry.kind === "gradient") {
      var stops = String(entry.value)
        .split(",")
        .map(function (part) {
          return part.trim();
        })
        .filter(Boolean);
      if (stops.length) {
        element.style.setProperty(
          "--swatch-background-image",
          "linear-gradient(to right, " + stops.join(", ") + ")",
        );
      }
    }
    element.setAttribute("data-im-color-applied", "1");
  }

  function applyAll(root) {
    if (!colorMap) return;
    var scope = root && root.querySelectorAll ? root : document;
    if (
      scope.nodeType === 1 &&
      scope.hasAttribute &&
      scope.hasAttribute("data-swatch")
    ) {
      applyToElement(scope);
    }
    var nodes = scope.querySelectorAll("[data-swatch]");
    for (var i = 0; i < nodes.length; i++) {
      applyToElement(nodes[i]);
    }
  }

  // Brand-level default diagonal color, applied once at :root so it covers every
  // sold-out chip (including colors not in the master). Per-color values, set on
  // the element, win over this.
  function applyBrandDefault(color) {
    if (!color) return;
    var root = document.documentElement;
    root.style.setProperty("--swatch-soldout-line-color-brand", color);
    var cross = buildCrossSvg(color);
    root.style.setProperty("--swatch-cross-svg", cross);
    root.style.setProperty("--swatch-cross-hover", cross);
    root.style.setProperty("--swatch-cross-active", cross);
  }

  function observe() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) applyAll(added[j]);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    var url;
    try {
      url = new URL(
        "/api/public/colors?brand=" + BRAND,
        defaultApiBaseUrl,
      ).toString();
    } catch (error) {
      return;
    }
    fetch(url, { mode: "cors" })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (payload) {
        if (!payload) return;
        applyBrandDefault(payload.soldOutLineColorDefault);
        colorMap = buildColorMap(payload);
        applyAll(document);
        observe();
      })
      .catch(function () {
        // Network/CORS failure: keep the theme's swatch_value_list colors.
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
